import { render, staticRenderFns } from "./mini_games.vue?vue&type=template&id=4ccda710&"
import script from "./mini_games.vue?vue&type=script&lang=js&"
export * from "./mini_games.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports